import { useState } from "react";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";
import { fmtDate } from "@/lib/api";

export const METRICS = [
  { key: "weight", label: "Peso", unit: "kg" },
  { key: "upper_abdomen", label: "Addome alto", unit: "cm" },
  { key: "waist", label: "Sopra ombelico", unit: "cm" },
  { key: "abdomen", label: "Sotto ombelico", unit: "cm" },
  { key: "thigh", label: "Coscia dx", unit: "cm" },
  { key: "thigh_l", label: "Coscia sx", unit: "cm" },
  { key: "above_knee", label: "Sopra ginocchio dx", unit: "cm" },
  { key: "above_knee_l", label: "Sopra ginocchio sx", unit: "cm" },
];

export function ProgressChart({ visits, prefix = "progress" }) {
  const [metric, setMetric] = useState("weight");
  const m = METRICS.find((x) => x.key === metric);
  const data = visits.filter((v) => v[metric] != null).map((v) => ({ date: fmtDate(v.date, { day: "2-digit", month: "short" }), value: v[metric] }));

  return (
    <div className="card" data-testid={`${prefix}-chart`}>
      <div className="mb-4 flex flex-wrap gap-2">
        {METRICS.map((x) => (
          <button key={x.key} onClick={() => setMetric(x.key)} data-testid={`${prefix}-metric-${x.key}`}
            className={`rounded-full px-3 py-1.5 text-xs font-semibold transition-colors ${
              metric === x.key ? "bg-[#3d655b] text-white" : "bg-slate-100 text-slate-600 hover:bg-[#edf2ef]"}`}>
            {x.label}
          </button>
        ))}
      </div>
      {data.length < 1 ? (
        <div className="grid h-56 place-items-center text-sm text-slate-400">Nessun dato per {m.label.toLowerCase()}</div>
      ) : (
        <div className="h-64">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={data} margin={{ top: 10, right: 16, left: -10, bottom: 0 }}>
              <CartesianGrid stroke="#eef2f6" vertical={false} />
              <XAxis dataKey="date" tick={{ fontSize: 11, fill: "#64748b" }} axisLine={false} tickLine={false} />
              <YAxis domain={["auto", "auto"]} tick={{ fontSize: 11, fill: "#64748b" }} axisLine={false} tickLine={false} />
              <Tooltip formatter={(v) => [`${v} ${m.unit}`, m.label]} contentStyle={{ borderRadius: 12, border: "1px solid #e2e8f0", fontSize: 12 }} />
              <Line type="monotone" dataKey="value" stroke="#3d655b" strokeWidth={3} dot={{ r: 4, fill: "#fff", stroke: "#3d655b", strokeWidth: 2 }} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
}
